import { NgModule } from '@angular/core';

import { FilterPipe, LIB_CommonModule, SearchPipe, SorterPipe } from 'pbc.angular';

import { ArchivService } from '.';

@NgModule({
  imports: [LIB_CommonModule],
  providers: [ArchivService, SearchPipe, FilterPipe, SorterPipe],
  exports: [],
})
export class ArchivServiceModule {}
